import ShieldTickIcon from './ShieldTickIcon'

export default ShieldTickIcon
